// extracted by mini-css-extract-plugin
export default {"box":"MultiSelectBox_box__mqAvR"};